import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { put, select, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  TgvEingabeTarget,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { isUntouchedTier } from '../models/eingabeAnchors';
import { TgvActions } from '../tgvActions';

export function* watchEingabeTarget(): SagaIterator {
  yield takeEvery(
    GlobalActions.TIERGRUPPE_EINGABE_TARGET_SET,
    safeSaga(eingabeTargetSaga, App.TGV),
  );
}

export function* eingabeTargetSaga(action: GlobalAction<TgvEingabeTarget>): SagaIterator {
  if (action.payload?.target !== 'NEW_CARD') {
    return;
  }
  const { tiere }: IAppState['tiergruppe'] = yield select((state: IAppState) => state.tiergruppe);
  const lastCard = tiere[tiere.length - 1];
  if (!lastCard || !isUntouchedTier(lastCard)) {
    yield put(new TgvActions().tierAdded());
  }
}
